import loadScript from './script-loader';

export default function deferLoadScript(url, secondsTimeout) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      loadScript(url)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    }, secondsTimeout);
  });
}
